import { StateCreator } from 'zustand';

type LocalCompany = {
  companyId: string | undefined;
  optedOut: boolean | undefined;
};

export type CompanySlice = {
  company: LocalCompany;
  setCompanyId: (companyId: string | undefined) => void;
  clearCompanyId: () => void;
  setOptedOut: (value: boolean) => void;
  clearOptedOut: () => void;
};

const defaultValue: LocalCompany = {
  companyId: undefined,
  optedOut: undefined,
};

export const createCompanySlice: StateCreator<CompanySlice> = set => ({
  company: defaultValue,
  setCompanyId: companyId =>
    set(state => ({
      company: {
        ...state.company,
        companyId,
      },
    })),
  clearCompanyId: () =>
    set(state => ({
      company: {
        ...state.company,
        companyId: undefined,
      },
    })),
  setOptedOut: value =>
    set(state => ({
      company: {
        ...state.company,
        optedOut: value,
      },
    })),
  clearOptedOut: () =>
    set(state => ({
      company: {
        ...state.company,
        optedOut: undefined,
      },
    })),
});
